// PARITY-0: today's ⌘K commands as registrations (moved from app-shell.tsx unchanged, in the same
// order): Invite person, New seat, Add digital employee and Enter numbers for the managers who
// open Setup (Enter numbers with the `kpi` add-on), then Notification settings for everyone.
import { ArmchairIcon, BellIcon, ListPlusIcon, RocketIcon, UserPlusIcon } from "lucide-react";
import { registerCommand, type ShellCommand } from "./command-registry";

export const DEFAULT_COMMANDS: readonly ShellCommand[] = [
  {
    id: "cmd-invite",
    title: "Invite person",
    order: 10,
    icon: UserPlusIcon,
    when: (ctx) => ctx.setupOpen,
    // MODALS: the dialog opens over the current page (Setup › People's `?invite=1` otherwise).
    run: (ctx) =>
      ctx.quickAdd ? ctx.quickAdd("invite") : ctx.go("/c/$slug/setup/people", { invite: "1" }),
  },
  {
    id: "cmd-seat",
    title: "New seat",
    order: 20,
    icon: ArmchairIcon,
    when: (ctx) => ctx.setupOpen,
    run: (ctx) =>
      ctx.quickAdd ? ctx.quickAdd("seat") : ctx.go("/c/$slug/setup/seats", { new: "1" }),
  },
  // DE-WIZARD: one "Add digital employee" (it offers the self-serve deploy too).
  {
    id: "cmd-de-new",
    title: "Add digital employee",
    order: 30,
    icon: RocketIcon,
    when: (ctx) => ctx.setupOpen,
    run: (ctx) => ctx.go("/c/$slug/setup/des/new"),
  },
  {
    id: "numbers",
    title: "Enter numbers",
    order: 40,
    icon: ListPlusIcon,
    when: (ctx) => ctx.setupOpen && ctx.features.kpi,
    run: (ctx) => ctx.go("/c/$slug/kpis/entry/numbers"),
  },
  {
    id: "cmd-notifications",
    title: "Notification settings",
    order: 90,
    icon: BellIcon,
    when: () => true,
    run: (ctx) => ctx.go("/c/$slug/notifications"),
  },
];

const offs = DEFAULT_COMMANDS.map(registerCommand);
// A hot reload re-runs this module: the old registrations go first (no duplicate id).
import.meta.hot?.dispose(() => {
  for (const off of offs) off();
});
